import { StaticQuery, graphql } from 'gatsby'

import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'
import React from 'react'

function SEO({ description, lang, meta, keywords, title, nochat }) {
  return (
    <StaticQuery
      query={detailsQuery}
      render={(data) => {
        const metaDescription =
          description || data.site.siteMetadata.description
        const author = data.site.siteMetadata.author
        const COPYRIGHT =
          '&amp;copy; 2019 Genesis HealthCare&lt;sup>&amp;reg;&lt;/sup>'

        return (
          <Helmet
            htmlAttributes={{
              lang,
            }}
            title={title}
            titleTemplate={`%s | ${data.site.siteMetadata.title}`}
            meta={[
              {
                id: `MetaDescription`,
                name: `description`,
                content: metaDescription,
              },
              {
                id: `MetaAuthor`,
                name: `author`,
                content: author,
              },
              {
                id: `MetaCopyright`,
                name: `COPYRIGHT`,
                content: COPYRIGHT,
              },
              {
                id: 'MetaRobots',
                name: 'ROBOTS',
                content: 'INDEX, FOLLOW',
              },
              {
                name: 'REVISIT-AFTER',
                content: '1 DAYS',
              },
              {
                name: 'RATING',
                content: 'GENERAL',
              },
              {
                property: `og:title`,
                content: title,
              },
              {
                property: `og:description`,
                content: metaDescription,
              },
              {
                property: `og:type`,
                content: `website`,
              },
              {
                name: `twitter:card`,
                content: `summary`,
              },
              {
                name: `twitter:creator`,
                content: data.site.siteMetadata.author,
              },
              {
                name: `twitter:title`,
                content: title,
              },
              {
                name: `twitter:description`,
                content: metaDescription,
              },
            ]
              .concat(
                keywords.length > 0
                  ? {
                      name: `keywords`,
                      id: `MetaKeywords`,
                      content: keywords.join(`, `),
                    }
                  : []
              )
              .concat(meta)}
          >
            <link rel="icon" href="/images/favicon.png" />
          </Helmet>
        )
      }}
    />
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  keywords: [],
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.array,
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
}

export default SEO

const detailsQuery = graphql`
  query DefaultSEOQuery {
    site {
      siteMetadata {
        title
        description
        author
      }
    }
  }
`
